"use strict";
exports.__esModule = true;
function isContentLoaded(init, reInit) {
    document.addEventListener("DOMContentLoaded", init);
    if (document.readyState === "interactive" ||
        document.readyState === "complete") {
        init();
    }
    reInit(5000);
}
exports["default"] = isContentLoaded;
